module.exports = __webpack_public_path__ + "img/MAGAZINE UNLOADER (Ergonomic Type).e4004fbd.jpg";